<template>
  <div>
  <usernav></usernav>
    <el-col v-if="loading" class="C-PageLoading">
      <div class="Spinner spinner-grow text-primary"></div>
    </el-col>
    <div v-if="!loading">
    <el-col>
      <el-card shadow="never" :body-style="{padding: '16px',textAlign: 'left'}">
        <div class="G-title">
          <span>我的信息</span>
        </div>
        <div style="margin: 20px">
        <el-table
          :row-class-name="tableRowClassName"
          :data="tableData"
          style="margin: auto;"
          border
          >
          <el-table-column
            prop="title"
            label="标题"
            show-overflow-tooltip
            >
          </el-table-column>
          <el-table-column
            prop="cid"
            label="地区"
            v-if="show"
            width="180px">
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            width="100px"
            >
          </el-table-column>
          <el-table-column
            prop="points"
            label="获得积分"
            v-if="show"
            width="80px">
          </el-table-column>
          <el-table-column
            prop="browse"
            label="浏览"
            v-if="show"
            width="70px">
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="日期"
            v-if="show"
            width="100px">
          </el-table-column>
        </el-table>
        </div>
      </el-card>
    </el-col>
    <el-col>
      <el-card shadow="never" :body-style="{margin: '20px'}" style="margin:0">
        <el-pagination
          :small=true
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="24"
          :pager-count="5">
        </el-pagination>
      </el-card>
    </el-col>
    </div>
  </div>
</template>

<script>
import Usernav from '@/components/base/header/usernav'
import {request} from '../../network/request'
export default {
  name: 'myinfo',
  components: {Usernav},
  methods: {
    tableRowClassName ({row, rowIndex}) {
      if (row.status === '审核通过') {
        return 'success-row'
      } else if (row.status === '审核拒绝' || row.status === '举报下架') {
        return 'warning-row'
      }
      return ''
    },
    handleCurrentChange (val) {
      this.page = val
      this.get_info()
    },
    get_info () {
      let data = new URLSearchParams()
      data.append('page', this.page)
      request({
        url: '/api/myinfo',
        method: 'post',
        data: data
      }).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted () {
    this.get_info()
    if (this.screenWidth <= 991) {
      this.show = false
    } else {
      this.show = true
    }
    window.onresize = () => {
      return (() => {
        window.screenWidth = window.innerWidth
        this.screenWidth = window.screenWidth
      })()
    }
  },
  watch: {
    screenWidth (val) {
      this.screenWidth = val
      if (this.screenWidth <= 991) {
        this.show = false
      } else {
        this.show = true
      }
    }
  },
  data () {
    return {
      screenWidth: window.innerWidth,
      show: true,
      tableData: [],
      page: 1,
      total: 0,
      loading: true
    }
  }
}
</script>

<style scoped>
  .G-title {
    border-bottom: 1px solid #f2f2f2 !important;
    padding-bottom: 10px;
    justify-content: space-between !important;
    display: flex !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/user/myinfo.vue